import React from 'react';

import { ExtensionManifest } from '@atlaskit/editor-common/extensions';

import { CodeSuggestion } from './code-suggestion';

export function getCodeSuggestionsManifest(fileMeta: any): ExtensionManifest {
  return {
    title: 'Suggest Code',
    type: 'com.atlassian.bbc.code-suggestions',
    key: 'codesuggestions',
    description: 'Make a code suggestion',
    icons: {
      '48': () =>
        import('@atlaskit/icon/glyph/editor/code').then(mod => mod.default),
    },
    modules: {
      fields: {
        custom: {
          fileMeta,
        },
      },

      quickInsert: [
        {
          key: 'suggest',
          action: {
            type: 'node',
            key: 'node-code-suggest-editing-mode',
          },
        },
      ],
      nodes: {
        'node-code-suggest-editing-mode': {
          type: 'extension',
          render: async () => {
            await Promise.resolve();
            return () => <CodeSuggestion isEditMode fileMeta={fileMeta} />;
          },
        },
      },
    },
  };
}
